import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { useNavigate } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { setData } from "../../core/redux/app/Actions"
import { useDWOptions } from "../../core/utils/hooks/useDwOptions"
import { CompleteESMScreen } from "../../screen/CompleteESMScreen"
import { useProjects, useScope } from "../SelectProjectCompanyContainer"
import Send from "../../core/communication"
import { customToast } from "../../components/Toast"
import { formattedProjects } from "../../components/EsmModal"

const loadData = async (scopeId, dispatch, scopeType) => {
  let response = await Send.get(`/scale-project/${scopeId}`, `scopeType=${scopeType}`)
  if (!response || !Array.isArray(response)) {
    response = []
  }

  const list =
    response.map((item) => ({
      id: item?.id,
      title: item?.title || "",
      description: item?.description || "",
    })) || []

  dispatch(setData({ esmList: list }))
}

const CompleteESMContainer = () => {
  const { scope, scopeType, scopeName } = useScope();
  const { projects } = useProjects();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const esmList = useSelector((state) => state.app?.esmList) || [];
  const [dw] = useDWOptions();
  const [currentESM, setCurrentESM] = useState({});
  const [isAllProjectSelected, setAllProjectSelected] = useState(false);
  const [values, setValues] = useState({});
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [reload, setReload] = useState(false);

  const { register, getValues, control, setValue } = useForm({
    mode: "onChange",
  })

  useEffect(() => {
    if (scope?.id && !modalIsOpen) {
      loadData(scope?.id, dispatch, scopeType)
    }
  }, [scope?.id, modalIsOpen, reload])

  useEffect(() => {
    if (!modalIsOpen) {
      setValue("title", "")
      setValue("description", "")
      setIsUpdate(false)
    }
  }, [modalIsOpen])

  useEffect(() => {
    if(isUpdate && Array.isArray(values?.projects)) {
      const projectsToUpdate = values?.projects.map(item => ({ project: item?.value, scale: currentESM?.id }))
      updateEsmProjects({ scaleId: currentESM?.id, scaleProjects: projectsToUpdate } || {});
    }
  }, [JSON.stringify(values?.projects)])

  const reloadData = () => {
    setReload((prev) => !prev)
    setModalIsOpen(false)
  }

  const saveNewESM = async () => {
    const newValues = {
      ...getValues(),
      ...values,
      projects: values?.projects.map((item) => item?.value) || [],
      config: '[]'
    }

    const response = await Send.post("/scale", newValues)
    if(response?.status === 'success') {
      customToast('Item atualizado', 'success');
    } else {
      customToast('Erro ao atualizar escala', 'error');
    }

    reloadData()
  }

  const updateEsmProjects = async (projectList) => {
    const response = await Send.put('/scale-project', projectList)

    if(response?.status === 'success') {
      customToast('Projetos da escala atualizados', 'success');
    } else {
      customToast('Erro ao atualizar projetos', 'error');
    }
  }

  const updateESM = async () => {
    const newValues = {
      ...values,
      ...getValues(),
    }

    delete newValues.projects;
    if(!newValues.config) newValues.config = '[]'
    const response = await Send.put(`/scale/${newValues?.id}`, newValues);

    if(response?.status === 'success') {
      customToast('Item atualizado', 'success');
    } else {
      customToast('Erro ao atualizar escala', 'error');
    }

    reloadData()
  }

  const onChangeValues = (field) => {
    return (value) => {
      setValues((values) => ({ ...values, [field]: value }))
    }
  }

  const openModalUpdate = async (data = {}) => {
    setValues({})
    const response = await Send.get(`/scale/${data.id}`);

    if (!response || !response?.id) {
      // error
      customToast("Erro ao buscar informações", 'error');
      console.log("ERRO ao buscar informações")
      return;
    }

    const allProjects = response?.scaleProjects
    ? response?.scaleProjects.map((item) => ({
      value: item?.project?.id,
      label: item?.project?.description,
    })) : []
    
    setValues({ projects: allProjects, ...data })
    setCurrentESM(response);
    setValue("title", response?.title)
    setValue("description", response?.description)
    setIsUpdate(true)
    setModalIsOpen(true)
  }

  const goToDetails = (id) => {
    if (id) {
      navigate(`/esm/indicators/${id}`)
    }
  }

  const removeESM = async (id) => {
    const response = await Send.delete(`/scale/${id}`)
    
    response?.status === "success" ? 
      customToast("ESM removido", "success") : 
      customToast("Erro ao remover ESM", "error")

    reloadData()
  }

  const handleSelectAll = () => {
    if(isAllProjectSelected) {
      setValues(curr => ({ ...curr, projects: [{ value: scope?.id, label: scopeName }] }));
      setAllProjectSelected(false);
      return;
    } else if (Array.isArray(projects)) {
      const newProjects = formattedProjects(projects);
  
      setValues(curr => ({ ...curr, projects: newProjects }));
      setAllProjectSelected(true);
    }
  }

  return (
    <CompleteESMScreen
      {...{
        esmList,
        setModalIsOpen,
        modalIsOpen,
        dw,
        values,
        onChangeValues,
        openModalUpdate,
        isUpdate,
        register,
        control,
        goToDetails,
        saveNewESM,
        updateESM,
        removeESM,
        isAllProjectSelected,
        handleSelectAll,
        isAllProjectSelected
      }}
    />
  )
}

export default CompleteESMContainer
